import React from 'react';
import { Box } from '@mui/material';

import { useAsset, EnvConfiguration } from '@ocx/data-configuration';

export interface IVendorLogoComponentProps {
  onClick?: () => void;
}

export const VendorLogoComponent: React.FC<IVendorLogoComponentProps> = (props) => {
  const { onClick } = props;

  const navLogoSrc = useAsset('NavLogo');

  return (
    <Box
      component="img"
      src={navLogoSrc}
      onClick={onClick}
      onKeyDown={onClick}
      alt={EnvConfiguration.marketing.title}
      role="presentation"
      sx={{ maxHeight: 48, cursor: 'pointer' }}
    />
  );
};
